import { RichText, RichTextKind } from "../../../../model/question/RichText";

export function transHTMLText(r: RichText): RichText {
    const h = r.pure_text.split("\n").join("<br/>");
    return {
        ...r,
        type: RichTextKind.HTMLText,
        html_text: "<div><p>" + h + "</p></div>",
        pure_text: "",
    };
}
